import { render, staticRenderFns } from "./ProcessosSeletivos.vue?vue&type=template&id=f232d70c&scoped=true"
import script from "./ProcessosSeletivos.vue?vue&type=script&lang=js"
export * from "./ProcessosSeletivos.vue?vue&type=script&lang=js"
import style0 from "./ProcessosSeletivos.vue?vue&type=style&index=0&id=f232d70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f232d70c",
  null
  
)

export default component.exports